module.exports = __webpack_public_path__ + "static/media/11d.0fc0affe.svg";